import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-verschieben';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteVerschiebenEffects {

    ChecklisteVerschieben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_VERSCHIEBEN),
        mergeMap((x: ac.PostChecklisteVerschiebenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteVerschieben(x.checklisteVerschiebenRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteVerschiebenErfolgreichAction(result, x.checklisteVerschiebenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteVerschiebenFehlerAction(error, x.checklisteVerschiebenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteCommandService);
        }
        return this.service;
    }
}
